import { Link } from "react-router-dom";

export default function WhatIsSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-6 md:px-10 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="lg:w-2/5 animate-slide-in-left">
            <div className="relative">
              <div className="rounded-3xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Organized%20product%20flat%20lay%20on%20dark%20walnut%20wood%20desk%20surface%2C%20fashion%20accessories%20and%20shopping%20items%20arranged%20neatly%2C%20natural%20daylight%20from%20nearby%20window%20creating%20soft%20shadows%2C%20editorial%20catalog%20photography%20style%2C%20warm%20neutral%20tones%20with%20pops%20of%20mustard%20and%20olive%2C%20no%20text%20overlay%2C%20high%20detail%20professional%20composition&width=800&height=1000&seq=what-is-jun27-v2&orientation=portrait"
                  alt="What is ItaobuySpreadsheet - organized shopping catalog"
                  className="w-full h-auto object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 bg-accent-500 text-background-50 px-5 py-2.5 rounded-full text-sm font-semibold shadow-sm">
                Updated Weekly
              </div>
            </div>
          </div>

          <div className="lg:w-3/5">
            <span className="text-xs font-semibold text-secondary-600 uppercase tracking-widest">
              About the Platform
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 mt-3 mb-6 leading-tight">
              What is
              <br />
              ItaobuySpreadsheet?
            </h2>
            <p className="text-base text-foreground-600 leading-relaxed mb-5">
              ItaobuySpreadsheet is a curated shopping system that helps users discover products from China through structured spreadsheets instead of traditional e-commerce browsing. Instead of searching manually, users get pre-organized product lists, verified agent recommendations, price and shipping comparisons, and fast ordering workflows.
            </p>
            <p className="text-base text-foreground-600 leading-relaxed mb-8">
              It saves time, reduces cost, and improves buying accuracy, making cross-border shopping from Taobao, 1688, and Weidian accessible to everyone, from beginners to experienced international buyers.
            </p>
            <Link
              to="/shopping-guide"
              className="inline-flex items-center gap-2 bg-foreground-950 hover:bg-foreground-800 text-background-50 font-semibold px-8 py-3.5 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer group"
            >
              Browse Shopping Guides
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}